function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 87.699,
  cy: 65.4022,
  r: 64.699,
  fill: "#33CBC3"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 87.699,
  cy: 65.4022,
  r: 64.699,
  fill: "#33CBC3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_12655_1858)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.0752 162.624L-10.7333 141.865L100.501 87.8911L177.309 105.017L66.0752 162.624Z",
  fill: "#BB001E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.4289 137.713L33.7255 120.414L171.946 53.4663L227.65 67.1327L89.4289 137.713Z",
  fill: "#00BEB4"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.580444 115.886L67.1624 132.569V150.769L0.580444 132.569V115.886Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.580444 115.886L67.1624 132.569L115.544 107.999L48.9623 91.3154L0.580444 115.886Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M115.544 107.999L67.1624 132.569V150.769L115.544 126.199V107.999Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.580444 115.886L67.1624 132.569M0.580444 115.886V132.569L67.1624 150.769M0.580444 115.886L48.9623 91.3154L115.544 107.999M67.1624 132.569V150.769M67.1624 132.569L115.544 107.999M67.1624 150.769L115.544 126.199V107.999",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1622 132.569L115.544 107.999V126.199L67.1622 150.769V132.569Z",
  fill: "#CCCCCC",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1624 132.57L0.580444 115.886V132.57L67.1624 150.77V132.57Z",
  fill: "#F9F9F9",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5486 122.142L33.8713 124.228V141.669L25.5486 139.394V122.142Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5486 122.142L33.8713 124.228L81.1157 99.2027L72.793 96.9277L25.5486 122.142Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4155 39.536L56.05 57.1901V128.019L17.4155 108.545V39.536Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4155 39.536L56.05 57.1901L110.539 45.906L71.2574 29.7383L17.4155 39.536Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M110.539 45.906L56.05 57.1901V128.019L110.539 113.823L110.539 45.906Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4155 39.536L56.05 57.1901M17.4155 39.536V108.545L56.05 128.019M17.4155 39.536L71.2574 29.7383L110.539 45.906M56.05 57.1901V128.019M56.05 57.1901L110.539 45.906M56.05 128.019L110.539 113.823L110.539 45.906",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0907 57.1901L17.4155 39.5967V108.605L56.0907 128.019V57.1901Z",
  fill: "#F9F9F9",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5587 49.5737L31.3687 45.8921V69.7364L39.5587 73.7989V49.5737Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5587 49.4968L31.3687 45.8151L80.6605 33.2593L89.1539 37.0184L39.5587 49.4968Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0907 57.0387L110.539 45.9067V113.914L56.0907 128.019V57.0387Z",
  fill: "#CCCCCC",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M134.806 125.781L172.42 106.787V143.303L134.806 162.297V125.781Z",
  fill: "#CCCCCC",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M134.806 125.764L83.239 112.853L83.239 148.211L134.806 162.296V125.764Z",
  fill: "#F9F9F9",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M134.806 125.764L83.239 112.853L120.701 93.7427L172.419 106.786L134.806 125.764Z",
  fill: "white",
  stroke: "#666666",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M102.652 117.706L109.022 119.326V136.513L102.652 134.746V117.706Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M102.652 117.752L109.104 119.374L145.726 99.9101L139.274 98.1406L102.652 117.752Z",
  fill: "#F9F9F9",
  stroke: "#999999",
  strokeLinejoin: "round"
});

function SvgBoxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 163,
    viewBox: "0 0 173 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12655_1858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 0,
    width: 130,
    height: 131
  }, _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.e45833c6.svg";
export { ForwardRef as ReactComponent };